// Report form steps configuration
export const STEPS = [
  { id: "category", label: "general.choose-category-step" },
  { id: "subcategory", label: "general.choose-subcategory" },
  { id: "description", label: "general.add-description-step" },
  { id: "review", label: "general.review" },
];
